<template>
    <v-card flat cols="12" md="12" sm="12" width="100%">
      <v-tabs v-model="tab" :showArrows="showArrows">
        <v-tab v-for="tab in tabs" :key="tab.label" active-class="activetab">
          {{ tab.label }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" :touchless="true">
        <v-tab-item v-for="tab in tabs" :key="tab.label">
          <v-card flat>
            <component :is="tab.section" :pageData="tab.pageData" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
</template>
<script>
export default {
  props: ['tabs', 'startTab', 'showArrows'],
  data() {
    return {
      tab: null,
    };
  },
  watch: {
    startTab() {
      this.tab = Number(this.startTab);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';

$tab-bg-color: #f8fafc;
$tab-text-color: #6b7280;
$tab-hover-bg-color: #f1f5f9;
$tab-hover-text-color: #4a5568;
$tab-active-bg-color: #ffffff;
$tab-active-text-color: #133b54;
$tab-active-border-color: #B0D35E;
$tab-items-bg-color: #ffffff;
$tab-items-border-color: #e2e8f0;

:deep(.v-tabs) {
  background-color: $tab-bg-color;
  border-radius: 8px 8px 0 0;
  
  .v-tab {
    background-color: transparent;
    color: $tab-text-color;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0.025em;
    transition: color $transition-fast ease, background-color $transition-fast ease;
    border-radius: 0;
    margin: 0;
    border-bottom: 3px solid transparent;
    
    &:hover {
      background-color: $tab-hover-bg-color;
      color: $tab-hover-text-color;
    }
    
    &--active {
      background-color: $tab-active-bg-color !important;
      color: $tab-active-text-color !important;
      font-weight: 600;
      box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.05);
      border-bottom: 3px solid $tab-active-border-color;
    }
  }
  
  .v-tabs-slider {
    display: none;
  }
}

:deep(.v-tabs-items) {
  background-color: $tab-items-bg-color;
  border-radius: 0 0 12px 12px;
  box-shadow: $shadow-md;
  border: 1px solid $tab-items-border-color;
  border-top: none;
}

:deep(.v-tab-item) {
  .v-card {
    box-shadow: none !important;
    border-radius: 0;
  }
}
</style>
